import { ButtonIcon, StepsFlow } from '@bluevalet/common-ui';
import HistoricIcon from '@bluevalet/react-icons/historic';
import OutsideWashIcon from '@bluevalet/react-icons/outside-wash';
import UserIcon from '@bluevalet/react-icons/user';
import ValetIcon from '@bluevalet/react-icons/valet';
import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { StepType, stepTypeHref, stepTypeOrder } from '../types';

const isPreviousOrSameStep = (current: StepType, step: StepType) =>
  stepTypeOrder.indexOf(step) <= stepTypeOrder.indexOf(current);

interface Props {
  currentStep: StepType;
  currentStepError: boolean;
}

const StepsMenu: FC<Props> = ({ currentStep, currentStepError }) => {
  const { t } = useTranslation();

  const menuItem = (id: number, step: StepType, label: ReactElement) => ({
    id,
    label,
    href: stepTypeHref[step],
    isActive: currentStep === step,
    isDisabled: !isPreviousOrSameStep(currentStep, step),
    isError: currentStep === step && currentStepError,
    isSuccess: isPreviousOrSameStep(currentStep, step),
  });

  const menu = [
    menuItem(
      1,
      StepType.booking,
      <ButtonIcon light data-cy="button-icon-2">
        <HistoricIcon size={24} />
        <span>{t('booking-menu_order')}</span>
      </ButtonIcon>,
    ),
    menuItem(
      2,
      StepType.services,
      <ButtonIcon light data-cy="button-icon-2">
        <OutsideWashIcon size={24} />
        <span>{t('booking-menu_services')}</span>
      </ButtonIcon>,
    ),
    menuItem(
      3,
      StepType.options,
      <ButtonIcon light data-cy="button-icon-2">
        <ValetIcon size={24} />
        <span>{t('booking-menu_options')}</span>
      </ButtonIcon>,
    ),
    menuItem(
      4,
      StepType.information,
      <ButtonIcon light data-cy="button-icon-2">
        <UserIcon size={24} />
        <span>{t('booking-menu_informations')}</span>
      </ButtonIcon>,
    ),
  ];

  return (
    <div className="StepsMenu">
      <StepsFlow steps={menu} />
    </div>
  );
};

export default StepsMenu;
